import React, { useContext, useMemo } from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';

import PodContext from '../../../../context/PodContext/PodContext';
import UserContext from '../../../../context/UserContext';
import { ALL_CLIENTS } from '../../../../context/PodContext/constants';
import { useCoachConfig } from '../../../hooks/useCoachConfig';

import texts from './texts.json';

const PodSelector = () => {
  const { pods, selectedPodId, updateSelectedPodId } = useContext(PodContext);
  const { userId: coachId } = useContext(UserContext);
  const { coachConfig, loading } = useCoachConfig(coachId);

  const podOptions = useMemo(() => (
    pods ? [...pods, { id: ALL_CLIENTS, name: texts.allClients }].map((pod) => (
      <MenuItem key={pod.id} value={pod.id}>
        {pod.name}
      </MenuItem>
    )) : null
  ), [pods]);

  if (!pods || loading || !coachConfig || !coachConfig.isPodEnabled) return null;

  return (
    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
      <Select
        value={selectedPodId || ALL_CLIENTS}
        onChange={(e) => updateSelectedPodId(e.target.value)}
      >
        {podOptions}
      </Select>
    </FormControl>
  );
};

export default PodSelector;
